import axios from 'axios';
import { Transactions } from 'models/report/transactions/transactions';
import { FsExpenditureTableTransactionRowDataProps } from 'ui-elements/tables/FsExpenditureTable/FsExpenditureTableTransactionRow/FsExpenditureTableTransactionRow';
import { getSnapshot } from 'mobx-state-tree';
import {
  SimilarTransactions,
  SimilarTransactionsSnapshot,
} from 'models/report/similar-transactions/similar-transactions';
import { AccountType, LoadingState } from 'globals/types';
import { temporaryEndpoints } from 'http/endpoints';
import { getPopulatedEndpoint } from 'models/utils/utils';

export interface PaginationInfo {
  itemsPerPage?: number;
  currentPage?: number;
  numberOfPages?: number;
}

interface GetTransactionsDataResponse {
  transactionArray: Array<FsExpenditureTableTransactionRowDataProps>;
  paginationInfo: PaginationInfo;
}

export const getTransactionsData = async ({
  userId,
  activeAccountType,
}: {
  userId: string | null;
  activeAccountType: AccountType;
}): Promise<GetTransactionsDataResponse | null> => {
  try {
    const url = `${getPopulatedEndpoint({
      userId,
      accountType: activeAccountType,
      endpoint: temporaryEndpoints.report.transactions,
    })}?max_per_page=10&category_id=Entertainment&currency=EUR&page=5`;
    const { data } = await axios.get(url);
    const transactionsModel = Transactions.create(data);
    transactionsModel.updateStatus(LoadingState.SUCCESS);
    return {
      transactionArray: transactionsModel.getTransactionArray(),
      paginationInfo: transactionsModel.getPaginationInfo(),
    };
  } catch (e) {
    return null;
  }
};

export const getSimilarTransactionsData = async (
  transactionId: string
): Promise<SimilarTransactionsSnapshot | null> => {
  try {
    const url = getPopulatedEndpoint({
      endpoint: temporaryEndpoints.report.similarTransactions,
      transactionId,
    });
    const { data } = await axios.get(url);
    const similarTransactionsModel = SimilarTransactions.create(data);
    similarTransactionsModel.updateStatus(LoadingState.SUCCESS);
    return getSnapshot(similarTransactionsModel);
  } catch (e) {
    return null;
  }
};
